<template>
  <com-header title="选择售后类型" bcColor="#f9f9f9">
    <div class="after_sale">
      <div class="goods">
        <div class="img">
          <div class="box_img" v-for="(v,i) in imgList" :key="i">
            <img :src="v" alt="图片加载失败">
          </div>
        </div>
        <div class="itr">
          <span>{{data.goodsMixNo}} </span>
          <span>{{data.attr1ContentName || ""}} </span>
          <span>{{data.attr2ContentName || ""}} </span>
          <span>{{data.attr3ContentName || ""}} </span>
          <span>{{data.attr4ContentName || ""}} </span>
          <span>{{data.goodsCategoryName}}</span>
        </div>
      </div>
      <div class="type_list">
        <div class="item" v-for="(v,i) in typeList" :key="i">
          <van-cell :title="v.typeText" :value="v.itr" icon="shopping-cart" is-link @click="onClickType(v)" />
        </div>
      </div>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
import { GetOrderAfterSaleGoodsMixInfo } from "@/pages/page1/api-work/index";
import { Button, Icon, cell } from "vant";
export default {
  metaInfo: { title: "选择售后" },
  components: {
    ComHeader,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [cell.name]: cell,
  },
  data() {
    return {
      data: {},
      imgList: [],
      typeList: [
        {
          typeText: "退货",
          itr: "退回收到的商品",
          value: 1,
        },
        {
          typeText: "换货",
          itr: "更换收到的商品",
          value: 2,
        },
        {
          typeText: "维修",
          itr: "维修收到的商品",
          value: 3,
        },
        // {
        //   typeText: "补件",
        //   itr: "商品漏发补件",
        //   value: 4,
        // },
      ],
    };
  },
  mounted() {
    this.getOrderGoodsMixInfo(this.$route.query.id);
  },
  methods: {
    getOrderGoodsMixInfo(orderGoodsMixId) {
      GetOrderAfterSaleGoodsMixInfo({ orderGoodsMixId }).then((res) => {
        // console.log("商品信息", res);
        this.data = res.data[0].orderGoodsMix;
        this.imgList.push(this.data.mainPreviewImageFilePath || "");
      });
    },
    onClickType(v) {
      // console.log(v);
      this.$router.push({
        path: "/rebackGoods",
        query: {
          orderGoodsMixId: this.data.id,
          applyProType: v.value,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.after_sale {
  background-color: #f9f9f9;
  // min-height: calc(100vh - 0.8rem);
  min-height: 100vh;
  box-sizing: border-box;
  .goods {
    background: #ffffff;
    padding: 0.26rem 0.3rem;
    border-bottom: 1px solid rgb(241, 241, 241);
    display: flex;
    .img {
      margin-top: 0.04rem;
      width: 1.4rem;
      height: 1.4rem;
      border: 1px solid rgba(168, 168, 168, 0.4);
      box-sizing: border-box;
      .box_img {
        width: 100%;
        height: 100%;
      }
    }
    .itr {
      width: calc(100% - 1.4rem);
      padding-left: 0.4rem;
      box-sizing: border-box;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      padding-top: 0.1rem;
    }
  }
  .type_list {
    margin-top: 0.4rem;
    background: #ffffff;
    box-sizing: border-box;
    padding: 0 0.3rem;
    .item {
      border-bottom: 1px solid #d7d7d7;
      &:last-child {
        border: none;
      }
      .van-cell {
        padding: 0.6rem 0;
        .van-icon-shopping-cart {
          font-size: 24px;
          color: #d9001b;
        }
        .van-cell__title {
          font-size: 16px;
        }
        .van-icon-arrow {
          font-size: 24px;
          color: #afafaf;
        }
      }
    }
  }
}
</style>